<template lang="pug">
  data-handler(
    v-model="serverFields"
    :method="getAdditionalFields"
    :serialize-data-items="serializeDataItems"
    show-loading
  )
    template(v-slot:loading)
      v-skeleton-loader.mx-n3(type="list-item-two-line")

    template(v-slot:default)
      div
        v-subheader.px-0(
          v-if="showSubheader && serverFields.length"
        ) Дополнительные поля
        api-form(
          v-model="formData"
          :method="save"
          :fields="extraFields"
          @hook:mounted="onInitialized"
        )
          template(v-slot:save-btn): div
</template>

<script>
import { PER_PAGE } from '@/constants/pagination';
import { USER_INPUT_TYPES_COMPONENTS } from '@/modules/Events/constants';

export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
    fields: {
      type: Object,
      default: undefined,
    },
    nomination: {
      type: Object,
      required: true,
    },
    showSubheader: {
      type: Boolean,
      default: false,
    },
    serializeDataItems: {
      type: Function,
      default: (items) => items,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      serverFields: [],
      formData: this.value,
    };
  },
  computed: {
    items() {
      const { fields, serverFields } = this;
      return fields ? Object.entries(fields) : Object.entries(serverFields);
    },
    hasRequiredItems() {
      return this.serverFields.some((i) => i.is_required);
    },
    extraFields() {
      const { items, getRules, serverFields } = this;

      return items.map(([idx, field]) => {
        const fieldData = serverFields.find((i) => i.id === field.id);
        const component = USER_INPUT_TYPES_COMPONENTS[fieldData.type];
        if (!component) return false;
        const extraField = {
          ...component,
          ...fieldData,
        };
        // console.log(USER_INPUT_TYPES_COMPONENTS[fieldData.type], extraField, fieldData);
        const attrs = extraField.attrs({ ...fieldData });

        return {
          // Нужно для валидации ошибок с сервера
          text: fieldData.title,
          pkey: `data.${idx}.data`,
          value: `${idx}.${fieldData.id}`,
          rules: getRules({ required: extraField.is_required }, extraField.rules),
          component: extraField.is,
          component_attrs: {
            ...attrs,
            'hide-details': false,
          },
        };
      }).filter(Boolean);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    async save({ data, obs }) {
      const outputData = Object.entries(data)
        .reduce((acc, [key, value]) => {
          const [index, id] = key.split('.');
          acc[index] = {
            user_event_info_request_id: id,
            data: value,
          };
          return acc;
        }, []);

      if (!outputData.length && !this.hasRequiredItems) {
        return new Promise((resolve) => resolve(true));
      }

      const payload = {
        data: { data: outputData },
        obs,
      };

      const resp = await this.$rApi.user.massStore(payload);
      return resp;
    },
    async getAdditionalFields() {
      const { nomination } = this;
      // const payload = {
      //   params: {
      //     'search[event_id]': event.id,
      //     'search[nomination_id]': nomination.id,
      //     'per-page': PER_PAGE.infinity,
      //     expand: 'document',
      //   },
      // };
      return this.event.getAttributes({
        'search[nomination_id]': nomination.id,
        'per-page': PER_PAGE.infinity,
        expand: 'document,options',
      });

      // const { response } = await this.$rApi.user.getUserEventInfoRequests(payload);
      // return response;
    },
    getRules(params = {}, rules) {
      const { required } = params;
      const rulesList = [...(rules || '').split('|') || []];

      if (required) rulesList.push('required');

      return rulesList.filter(Boolean).join('|');
    },
    onInitialized() {
      const { serverFields } = this;
      const { save } = this;

      this.$emit('onInitialized', {
        save: serverFields?.length ? save : null,
      });
    },
  },
};
</script>
